var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("mfa.title"),
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
        _vm._v(" " + _vm._s(_vm.$t("mfa.enter_code")) + " "),
      ]),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.formData, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("mfa.code"), prop: "mfa_code" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("mfa.placeholder"),
                  maxlength: "6",
                },
                model: {
                  value: _vm.formData.mfa_code,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "mfa_code", $$v)
                  },
                  expression: "formData.mfa_code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("components.cancel"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }